export enum ExpenseType {
  EVENT = 'EVENT',
  OTHER = 'OTHER',
}
